import React from "react";
import { Card, Grid, makeStyles, Typography } from "@material-ui/core";
import { FormattedMessage } from "react-intl";
import Number from "../../../../custom/Number";
import SectionTitleCollapse from "../../SectionCollapse";

const useStyles = makeStyles((theme) => ({
  card: {
    padding: theme.spacing(1),
    margin: theme.spacing(1, 2.5),
  },
  container: {
    padding: theme.spacing(1, 0),
  },
}));

const UsersReportSummary = ({ summary, disabled, loading, error, currentUser }) => {
  const classNames = useStyles();
  if (!summary) return null;

  const getDisplayValue = (value, enableZero = true) => {
    if (disabled) return "...";
    if (enableZero) return value ?? "...";
    return value || "...";
  };

  return (
    <SectionTitleCollapse in={!disabled}>
      <Card
        elevation={1}
        className={classNames.card}
      >
        <Grid
          container
          spacing={2}
          justifyContent="space-between"
          className={classNames.container}
        >
          <Grid
            item
            xs={12}
            sm={6}
            md={3}
          >
            <Typography
              variant="body1"
              color="primary"
              align="center"
            >
              <FormattedMessage id="app.report.totalCustodied" />
            </Typography>
            <Typography
              variant="body2"
              align="center"
            >
              <Number
                value={!disabled ? summary?.custodialValueTotal : null}
                currency="LCT"
                taxResidence={currentUser?.taxResidence}
                canCopySufix={false}
              />
            </Typography>
          </Grid>

          <Grid
            item
            xs={12}
            sm={6}
            md={3}
          >
            <Typography
              variant="body1"
              color="primary"
              align="center"
            >
              <FormattedMessage id="app.report.averageInvested" />
            </Typography>
            <Typography
              variant="body2"
              align="center"
            >
              <Number
                value={!disabled ? summary?.averageInvestmentTotal : null}
                currency="LCT"
                taxResidence={currentUser?.taxResidence}
                canCopySufix={false}
              />
            </Typography>
          </Grid>

          <Grid
            item
            xs={12}
            sm={6}
            md={3}
          >
            <Typography
              variant="body1"
              color="primary"
              align="center"
            >
              <FormattedMessage id="app.report.averageDuration" />
            </Typography>
            <Typography
              variant="body2"
              align="center"
            >
              {getDisplayValue(summary?.averageDurationTotal, false)}
            </Typography>
          </Grid>

          <Grid
            item
            xs={12}
            sm={6}
            md={3}
          >
            <Typography
              variant="body1"
              color="primary"
              align="center"
            >
              <FormattedMessage id="app.report.totalUsers" />
            </Typography>
            <Typography
              variant="body2"
              align="center"
            >
              {getDisplayValue(summary?.totalUsers)}
            </Typography>
          </Grid>
        </Grid>
      </Card>
    </SectionTitleCollapse>
  );
};

export default UsersReportSummary;
